import React, { useContext, useEffect, useState } from "react";
import styles from "../../assets/styles/home.module.css";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { createTheme, Theme, ThemeProvider } from "@mui/material/styles";
import { login, twofalogin, validate } from "../../utils/auth";
import { axiosInstance } from "../../utils/networking";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import { Typography } from "@mui/material";

// Extends the app theme (keeping its component overrides) with the magenta
// secondary colour; augmentColor derives light/dark from it the way a
// standalone createTheme would, so the buttons look exactly as before.
const theme = (outer: Theme) =>
  createTheme(outer, {
    palette: {
      secondary: outer.palette.augmentColor({
        color: { main: "#9e1f63", contrastText: "#fff" },
      }),
    },
  });
const HomePage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [currentUser, setCurrentUser] = useState();
  const [twoFactorCode, setTwoFactorCode] = useState("");
  const [resendCountDown, setResendCountDown] = useState(60);
  const [message, setMessage] = useState("");
  const [showForgot, setShowForgot] = useState(false);
  const [forgotLogin, setForgotLogin] = useState("");
  const [forgotMsg, setForgotMsg] = useState("");
  const navigate = useNavigate();
  const { setUser } = useContext(UserContext);

  const submitForgot = async () => {
    setForgotMsg("");
    try {
      await axiosInstance.post("/auth/forgot-password", {
        login: forgotLogin,
      });
    } catch (e) {
      // Intentionally ignore — response is generic either way.
    }
    setForgotMsg("If an account exists, an email has been sent.");
  };
  useEffect(() => {
    validate().then((res) => {
      if (res) {
        navigate("/dashboard");
      }
    });
  }, [navigate]);
  const loginSubmit = async () => {
    setMessage("");
    try {
      const user = await login(username, password);
      if (user) {
        setUser(user);
        setCurrentUser(user);
        if (process.env.REACT_APP_NODE_ENV !== "production") {
          navigate("/dashboard");
        }
        setResendCountDown(60);
        setInterval(() => {
          setResendCountDown((prev) => prev - 1);
        }, 1000);
      } else {
        setMessage("Invalid username or password, try again.");
      }
    } catch (error) {
      console.error(
        "You have an error in your code or there are Network issues.",
        error
      );
    }
  };

  const twoFactorSubmit = async () => {
    const user = await twofalogin(username, password, twoFactorCode);
    console.log("user", user);
    if (user) {
      setUser(user);
      setCurrentUser(user);
      navigate("/dashboard");
    } else {
      setMessage("Invalid verification code, try again later.");
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.login}>
        {currentUser ? (
          <Stack spacing={3}>
            <TextField
              sx={{ textAlign: "center" }}
              label="Verification Code"
              type="search"
              onChange={(e) => {
                setTwoFactorCode(e.target.value);
              }}
            />
            <Typography variant="body1" color="error">
              {message}
            </Typography>
            <Button disabled={resendCountDown > 0} onClick={loginSubmit}>
              Get new code {resendCountDown > 0 ? `in ${resendCountDown}s` : ""}
            </Button>
            <ThemeProvider theme={theme}>
              <Button
                variant="contained"
                color={"secondary"}
                onClick={twoFactorSubmit}
              >
                Submit
              </Button>
            </ThemeProvider>
          </Stack>
        ) : (
          <>
            <div>
              <h1>THRIVE Drive User Log in</h1>
            </div>
            <Stack spacing={3}>
              <TextField
                label="Username"
                type="search"
                onChange={(e) => {
                  setUsername(e.target.value);
                }}
              />
              <TextField
                label="Password"
                type="password"
                autoComplete="current-password"
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />
              <Typography variant="body1" color="error">
                {message}
              </Typography>
              <ThemeProvider theme={theme}>
                <Button
                  variant="contained"
                  color={"secondary"}
                  onClick={loginSubmit}
                >
                  Continue
                </Button>
              </ThemeProvider>
              <Button
                size="small"
                onClick={() => setShowForgot((v) => !v)}
                sx={{ textTransform: "none" }}
              >
                Forgot password?
              </Button>
              {showForgot ? (
                <Stack spacing={2}>
                  <TextField
                    label="Email or username"
                    type="search"
                    onChange={(e) => setForgotLogin(e.target.value)}
                  />
                  {forgotMsg ? (
                    <Typography variant="body2" color="secondary">
                      {forgotMsg}
                    </Typography>
                  ) : null}
                  <ThemeProvider theme={theme}>
                    <Button
                      variant="outlined"
                      color={"secondary"}
                      onClick={submitForgot}
                    >
                      Send reset link
                    </Button>
                  </ThemeProvider>
                </Stack>
              ) : null}
            </Stack>
          </>
        )}
      </div>
    </div>
  );
};

export default HomePage;
